import React from "react";
import type {Permission} from "./RightsSystem.ts";
import {useIsAuthorized} from "./withPermission.tsx";

export interface ShowPermittedOnlyProps {
    permission: Permission;
    children: React.ReactNode;
}

export const ShowPermittedOnly = ({permission, children}: ShowPermittedOnlyProps) => {
    const isAuthorized = useIsAuthorized(permission);
    return isAuthorized ? <>{children}</> : null;
};
